export class SearchModel {
    source: string;
    type: string;
    subType: string;
    department: string;
    priority: string;
    status: string;
    ticketNumber:string;
    showAllTickets:boolean;
    assignedTo:any;
    overDueCount:boolean;
    email?:string
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/ticketingsystem/search.model.ts